import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useIncoTermService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [incoSearchQuery, setIncoSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(incoSearchQuery);

  const allIncoTermService = useQuery({
    queryKey: [...CACHE_KEYS.INCO_TERMS, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.INCO_TERMS,
        searchParams: {
          "filter[name]": debouncedQuery,
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allIncoTermService },
    states: { incoSearchQuery, setIncoSearchQuery },
  };
};
